import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditTransferGoods from '../components/addEditTransferGoods.vue';

var EditTransferGoodsPage = function (_super) {
  __extends(EditTransferGoodsPage, _super);

  function EditTransferGoodsPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EditTransferGoodsPage = __decorate([Component({
    components: {
      AddEditTransferGoods: AddEditTransferGoods
    }
  })], EditTransferGoodsPage);
  return EditTransferGoodsPage;
}(Vue);

export default EditTransferGoodsPage;